export default {
    name: 'GS쇼핑어시스턴트-데모',
    header: 'GS쇼핑어시스턴트-데모',
    thumbnail: {
      bot: `/assets/gsshop/gsshop_chat_ai.png`,
      user: `/assets/me.png`,
    },
    palette: {
      primary: '#7ED957',
      primary10: '#F1FBEF',
    },
    introduction:
      '쇼핑에 대한 모든 것을 알려드릴게요.\n무엇을 질문할지 모르겠다면, 아래 질문을 눌러보세요.',
    notice:
      'GS쇼핑어시스턴트는 OpenAI가 제공하는 서비스를 활용하는 것으로 이용 시 입력되는 데이터는 OpenAI에도 제공되며, 제공 이후 OpenAI의 데이터 관리 정책에 따라 관리됩니다. 또한 고객님의 소중한 개인정보 보호를 위해 GS쇼핑어시스턴트 이용 시 개인정보는 입력하지 않도록 주의 바랍니다.',
    madeBy: 'presented by BUZZNI',
    sdk_title: 'GS쇼핑어시스턴트-데모',
  };
  